import type { SorterResult } from "antd/es/table/interface";

export const onTableChange = <TData extends Object>(
  onSortChange: (value: string) => void,
  defaultSortColumn?: string,
) => {
  return (_pagination: unknown, _filters: unknown, sorter: SorterResult<TData> | SorterResult<TData>[]) => {
    if (!Array.isArray(sorter) && onSortChange) {
      if (sorter.column) {
        onSortChange(`${sorter.order === "ascend" ? "" : "-"}${sorter.column.dataIndex as string}`);
      } else if (defaultSortColumn) {
        onSortChange(defaultSortColumn);
      }
    }
  };
};
